import React, { useMemo } from "react";
// ANT DESIGN COMPONENTS
import { Select } from "antd";
// CUSTOM HOOKS
import useGetAllLifts from "../../../customHooks/GET_requests/useGetAllLifts";
// COMPONENTS
import GlobalAlert2 from "../../home/GlobalAlert2";
// INTERFACE
import { LiftInterface } from "../../../interfaces/Lift.interface";

export default function SelectLifts({
  inputValue,
  inputOnChange,
  disabledInput,
  bankId = "",
}: {
  inputValue: string;
  inputOnChange: (id: string, name: string) => void;
  disabledInput: boolean;
  bankId?: string;
}) {
  // ************************************************ */
  // GLOBAL VARIABLES ******************************* */
  const { Option } = Select;

  // ************************************************ */
  // USE STATE VARIABLES **************************** */

  // ************************************************ */
  // REDUX SLICE VARIABLES ************************** */

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */

  // ************************************************ */
  // CUSTOM HOOKS *********************************** */
  const { lifts, isLoadingGetAllLifts, errorMessageGetAllLifts, isErrorGetAllLifts } =
    useGetAllLifts();

  // ************************************************ */
  // FUNCTIONS ************************************** */
  const filteredLifts = useMemo(
    () =>
      bankId
        ? lifts.filter((lift: LiftInterface) => String(lift.bankId) === String(bankId))
        : lifts,
    [lifts, bankId],
  );

  const onChange = (newValue: string) => {
    const index = filteredLifts.findIndex((item: any) => String(item.id) === newValue);
    if (index >= 0) {
      inputOnChange(String(filteredLifts[index].id), String(filteredLifts[index].name ?? ""));
    }
  };

  // ************************************************ */
  // USE EFFECT ************************************* */

  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <div className=" generalStyles__width100">
      <Select
        loading={isLoadingGetAllLifts}
        size="middle"
        className="generalStyles__width100"
        value={inputValue}
        placeholder="Lift"
        onChange={onChange}
        showSearch
        optionFilterProp="label" // Ensures Ant Design uses `label` for searching
        filterOption={(input, option) =>
          typeof option?.label === "string" &&
          option.label.toLowerCase().includes(input.toLowerCase())
        }
        disabled={disabledInput}
      >
        {filteredLifts.map((item: LiftInterface) => (
          <Option key={String(item.id)} value={String(item.id)} label={item.name}>
            <span className="generalStyles__info">
              {item && item.bank && item.bank && item.bank.name ? item.bank.name : ""}
            </span>
            : {item.name}
          </Option>
        ))}
      </Select>
      <GlobalAlert2
        isError={isErrorGetAllLifts}
        isSuccess={false}
        requestType="GET"
        error={errorMessageGetAllLifts}
        name="Lifts"
      />
    </div>
  );
}
